import { createApp, watch, ref } from 'vue'
import GalleriesApp from './GalleriesApp.vue'
import SearchbarApp from './SearchbarApp.vue'
import DestinationsLandingHeroApp from './DestinationsLandingHeroApp.vue'
import PropertyHeroPriceInfoApp from './PropertyHeroPriceInfoApp.vue'
import PointsCalculatorApp from './PointsCalculatorApp.vue'
import PartnerRedirectApp from './PartnerRedirectApp.vue'
import FriendlyRecaptchaWidgetApp from './FriendlyRecaptchaWidgetApp.vue'
import { mountHotelListAutomated } from './composables/useHotelListAutomated'
import {
  setupCalendars,
  useSetDefaultLocale,
  useStackModal,
  useQueryParamsToSbValues
} from '@common/lib-vue-common'
import { useToday, useDate, useAddDays } from '@common/lib-vue-common'
import '../node_modules/v-calendar/dist/style.css'
import { getQueryParams } from '@/composables/UseUrl'
import '@common/lib-vue-common/styles-legacy.css'
import '@common/lib-vue-common/components.css'
import '@common/lib-vue-common/icons.css'
import { isEnabled } from './isEnabled'
import UpsellingSliderApp from './UpsellingSliderApp.vue'

if (document.getElementById('galleries-app')) {
  console.log('galleries app')
  createApp(GalleriesApp).mount('#galleries-app')
}

const seachbar = document.getElementById('searchbar')

if (
  window?.appGlobalProps?.isWebextraPage &&
  !window?.appGlobalProps?.isWebextraMeetingEventsPage
) {
  const menu = document.querySelector('.rhg-menu-secondary')
  if (menu) {
    let lastScrollTop = 0
    window?.addEventListener(
      'scroll',
      () => {
        if (screen?.availWidth >= 768) {
          // desktop
          if (!menu.classList.contains('rhg-menu-secondary--sticky')) {
            menu.classList.add('rhg-menu-secondary--sticky')
          }
          return
        }

        // mobile
        var currentScrollTop = window?.pageYOffset || document?.documentElement?.scrollTop

        if (currentScrollTop > lastScrollTop) {
          // downscroll code
          if (menu.classList.contains('rhg-menu-secondary--sticky')) {
            menu.classList.remove('rhg-menu-secondary--sticky')
          }
        } else if (currentScrollTop < lastScrollTop) {
          // upscroll code
          if (!menu.classList.contains('rhg-menu-secondary--sticky')) {
            menu.classList.add('rhg-menu-secondary--sticky')
          }
        }
        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop
      },
      false
    )
  }
}

if (
  !!seachbar /*|| 
    !!window?.appGlobalProps?.isWebextraPage*/ &&
  isEnabled('cross.searchbar.redesign')
) {
  console.log('searchbar app')

  /*if (!seachbar) {
        const sb = document.createElement('div');
        sb.id = 'searchbar';
        document.body.appendChild(sb);
    }*/

  const showLog = (event, globalParams, params) => {
    console.log(`[NEW_CALENDARS]:${event}`, globalParams, params)
    localStorage.setItem(
      `[NEW_CALENDARS]:${event}`,
      JSON.stringify({
        url: location.href,
        globalParams,
        params
      })
    )
  }

  const onShowPriceCalendar = params => {
    // --- WebExtra-PropertyPage / * ---
    const memberOnlyRate = window?.appGlobalProps?.memberOnlyRate || 'false'
    const displayLoyaltyRates =
      !!window?.Cookie.read(window?.cookieDictionary.loyaltyConsentRates) ||
      !!window?.Cookie.read('auth')
    const onlyMembers = displayLoyaltyRates || (memberOnlyRate && memberOnlyRate !== 'false')
    const sourceOfBusiness = window?.device.desktop() ? 'desktop' : 'mobile'

    showLog('onShowPriceCalendar', { ...params, onlyMembers, sourceOfBusiness })
    useStackModal('price-calendar', { ...params, onlyMembers, sourceOfBusiness })
  }

  const onShowOfferCalendar = _params_ => {
    // --- Offers ---
    const queryParams = useQueryParamsToSbValues()
    const hotelCode = _params_?.hotelCode
    const minimumNights = _params_?.minimumNights || 1
    const start = _params_?.started ? useToday() : useDate(_params_?.reservationStartDate)
    const end = useAddDays(start, minimumNights)
    const dates = { start, end }
    // const occupancy = [{ adults: 2, children: [] }];
    const rate = _params_?.corporateId
      ? { type: 'corporateAccount', code: _params_.corporateId }
      : _params_?.pacCode
        ? { type: 'pac', code: _params_.pacCode }
        : { type: 'lowest' }
    const dealsPage =
      _params_?.trigger === 'multi-offers' &&
      rate.type === 'pac' &&
      !!rate.code &&
      isEnabled('offers.calendar.availability.additional.requests')
    const sourceOfBusiness = window?.device.desktop() ? 'desktop' : 'mobile'
    const origin = _params_?.origin

    const params = {
      ...queryParams,
      hotelCode,
      dates,
      // occupancy,
      rate,
      ...(dealsPage ? { dealsPage: true } : {}),
      minimumNights,
      sourceOfBusiness,
      origin
    }

    showLog('onShowOfferCalendar', _params_, params)
    useStackModal('availability-calendar', params)
  }

  const onShowSaverCalendar = params => {
    showLog('onShowSaverCalendar', params)
  }

  const onShowRedeemPointsCalendar = params => {
    showLog('onShowRedeemPointsCalendar', params)
  }

  const onShowModalModifyDates = _params_ => {
    // --- Discovery ---
    if (window?.appGlobalProps?.page === 'discovery') {
      const voucherCode = localStorage.getItem('voucherBook') || ''
      const queryParams = useQueryParamsToSbValues()
      const hotelCode = window?.appGlobalProps?.hotelCode
      const start = _params_?.checkInDate ? useDate(_params_?.checkInDate) : useToday()
      const end = _params_?.checkOutDate ? useDate(_params_?.checkOutDate) : useAddDays(start, 1)
      const dates = { start, end }

      const params = {
        ...queryParams,
        hotelCode,
        dates,
        voucherCode
      }

      showLog('onOpenSearchbarModal', _params_, params)
      useStackModal('simple-calendar', params)

      window.selectedHotel = null

      return
    }

    const params = {
      ..._params_,
      bookingId: document?.querySelector("input[name='bookingId']")?.value,
      firstName: document?.querySelector("input[name='mainGuest.firstName']")?.value,
      lastName: document?.querySelector("input[name='mainGuest.lastName']")?.value,
      roomReservationIds: document
        ?.querySelector("input[name='roomReservationIds']")
        ?.value?.split(',')
    }
    showLog('onShowModalModifyDates', params)
    useStackModal('modify-dates-calendar', params)
  }

  const onOpenSearchbarModal = _params_ => {
    // --- WebExtra-PropertyPage / Rooms ---
    if (window?.appGlobalProps?.searchBarType === 'hotel' && window?.appGlobalProps?.hotelCode) {
      const hotelCode = window?.appGlobalProps?.hotelCode
      showLog('onSearchModal', _params_, { hotelCode })
      useStackModal('simple-calendar', {
        hotelCode
      })
      return
    }

    // --- MyReservations(Cancelled reservations) ---
    if (window?.appGlobalProps?.searchBarType === 'rewards' && window?.selectedHotel?.code) {
      const hotelCode = window?.selectedHotel?.code

      const params = {
        hotelCode
      }

      showLog('onOpenSearchbarModal', _params_, params)
      useStackModal('simple-calendar', params)

      window.selectedHotel = null

      return
    }

    // --- Points Calculator ---
    if (window?.appGlobalProps?.pointsCalculator) {
      showLog('onOpenSearchbarModal', _params_, params)
      useStackModal('simple-calendar', params)
    }

    // --- RD ---
    const today = useToday()
    const queryParams = useQueryParamsToSbValues()
    const hotelCode = window?.selectedHotel?.code
    const minimumNights = _params_?.minNightsPerStay || window?.selectedHotel?.minNightsPerStay || 1
    const start =
      window?.selectedHotel?.openingDate && useDate(window?.selectedHotel?.openingDate) >= today
        ? useDate(window?.selectedHotel?.openingDate)
        : today
    const end = useAddDays(start, minimumNights)
    const dates = { start, end }
    const sourceOfBusiness = window?.device.desktop() ? 'desktop' : 'mobile'
    const origin = _params_?.origin
    const promotionCode = getQueryParams(window.location.search, 'promotionCode')

    const params = {
      ...queryParams,
      hotelCode,
      dates,
      minimumNights,
      sourceOfBusiness,
      origin,
      promotionCode
    }

    showLog('onOpenSearchbarModal', _params_, params)
    useStackModal('availability-calendar', params)

    window.selectedHotel = null
  }

  const onOpenSearchbarModalFromNearby = _params_ => {
    const hotelCode = window?.selectedHotel?.code
    const minimumNights = 1
    const start = useToday()
    const end = useAddDays(start, minimumNights)
    const dates = { start, end }
    const origin = _params_?.origin
    const sourceOfBusiness = window?.device.desktop() ? 'desktop' : 'mobile'
    const params = {
      hotelCode,
      dates,
      minimumNights,
      sourceOfBusiness,
      origin
    }

    showLog('onOpenSearchbarModalFromNearby', _params_, params)
    useStackModal('availability-calendar', params)
  }

  const onSearchModal = () => {
    // --- MyAccount ---
    const voucherCode = localStorage.getItem('voucherBook') || ''
    showLog('onSearchModal', {}, { voucherCode })
    useStackModal('simple-calendar', {
      voucherCode
    })
  }

  const app = createApp(SearchbarApp)
  setupCalendars(app)
  app.mount('#searchbar')

  window.searchBarVue = {
    $emit: (event, params) => {
      switch (event) {
        case 'showPriceCalendar':
        case 'show-price-calendar':
          onShowPriceCalendar(params)
          break
        case 'showOfferCalendar':
        case 'show-offer-calendar':
          onShowOfferCalendar(params)
          break
        case 'showSaverCalendar':
        case 'show-saver-calendar':
          onShowSaverCalendar(params)
          break
        case 'showRedeemPointsCalendar':
        case 'show-redeem-points-calendar':
          onShowRedeemPointsCalendar(params)
          break
        case 'showModalModifyDates':
        case 'show-modal-modify-dates':
          onShowModalModifyDates(params)
          break
        case 'openSearchbarModal':
        case 'open-searchbar-modal':
          onOpenSearchbarModal(params)
          break
        case 'openSearchbarModalFromNearby':
        case 'open-searchbar-modal-from-nearby':
          onOpenSearchbarModalFromNearby(params)
          break
        case 'bv::show::modal':
          switch (params) {
            case 'search-modal':
              onSearchModal(params)
              break
            default:
              showLog(`bv::show::modal:${params}`, {})
              break
          }
          break
        default:
          showLog(event, {})
          break
      }
    },
    __version: 'new'
  }
}

if (document.getElementsByClassName('hotel-list-automated-map').length !== 0) {
  console.log('hotel list automated app')
  useSetDefaultLocale()
  mountHotelListAutomated()
}

if (document.getElementById('destinations-landing-hero')) {
  console.log('destinations-landing-hero app')
  createApp(DestinationsLandingHeroApp).mount('#destinations-landing-hero')
}

if (document.getElementById('hero-searchbar')) {
  console.log('hero seachbar app')
  createApp(PropertyHeroPriceInfoApp).mount('#hero-searchbar')
}
if (document.getElementById('points-calculator-forms')) {
  console.log('points calculator app')
  const app = createApp(PointsCalculatorApp)
  setupCalendars(app)
  app.mount('#points-calculator-forms')
}
if (document.getElementById('partner-redirect-buttons')) {
  createApp(PartnerRedirectApp).mount('#partner-redirect-buttons')
}

document.querySelectorAll('div[id="friendlyRecaptcha-widget"]').forEach((el, index) => {
  console.log('frendlyRecaptcha widget app')
  const app = createApp(FriendlyRecaptchaWidgetApp)

  app.config.globalProperties.formLocation = el.attributes['form-location']?.value
  app.config.globalProperties.formName = el.attributes['form-name']?.value

  app.mount(el)
})

if (isEnabled('booking.pre.arrival') && location.href.includes('/reservation/summary')) {
  const timer = setInterval(() => {
    console.log('try mounting upselling slider app...')
    const el = document.getElementById('upselling-slider-app')
    if (el && window.appGlobalProps?.upsellingSlider) {
      el.style.display = 'block'
      const app = createApp(UpsellingSliderApp)
      app.mount('#upselling-slider-app')
      clearInterval(timer)
      console.log('upselling slider app mounted!')
    }
  }, 1000)
}
